import React, {Component} from 'react';
import {config} from '../libs/utils/Const.js';
import {connect} from "react-redux";

class NavBarLogo extends Component {
    render() {
        const {configReducer: {history}} = this.props;
        //console.log('render NavBarLogo');
        return (
            <a className="image" onClick={() => {
                history.goHome()
                }}>
                <img src={config.navBar.icon} style={{maxWidth: 100, maxHeight: 35,paddingBottom:10}} alt={'logo-empresa'}/>
            </a>
        );
    }
}


const mapStateToProps = store => {
    return {configReducer: store.ConfigReducer};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavBarLogo);
